export const Notice = "notice";
export const QnA = "qna";
export const FAQ = "faq";
